import { MAINTENANCE_PAGE } from '../../constants/pages';

// The one place that decides whether the current path IS the maintenance
// preview (see scripts/maintenance/README.md - visiting /maintenance directly
// is the documented way to see it without touching a shared environment).
// Prefix match, not equality: AppRoutes registers MAINTENANCE_PAGE without
// `exact`, so /maintenance/anything renders the page too.
//
// Shared by useInitHook (which must not fire its startup dispatches while
// this is true) and App.js (which must disable the idle/refresh machinery for
// the same reason - see useRefreshHook). Keeping one implementation means the
// two consumers cannot silently drift apart on what counts as "showing the
// maintenance page".
export function isOnMaintenancePagePath(pathname) {
  return (
    pathname === MAINTENANCE_PAGE || pathname.startsWith(`${MAINTENANCE_PAGE}/`)
  );
}
